import client from "../utils/ApiHelper.js";
import { getLocalAuth, setLocalAuth } from "../utils/AuthUtils.js";
import ErrorException from "../utils/Exceptions.js";

async function fetchAllUser() {
    try {
        let res = await client.get("/user");

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function fetchOneUser(id) {
    try {
        let res = await client.get("/user/user_id/" + id);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function createUser(name, username, email, password, privilege_id, department_id, image) {
    const form = new FormData();
    form.append("name", name);
    form.append("username", username);
    form.append("email", email);
    form.append("password", password);
    form.append("privilege_id", privilege_id);
    form.append("department_id", department_id);
    form.append("image", image);


    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }

    try {
        let res = await client.post("/user/create", form, config);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function updateUser(id, name, username, email, password, privilege_id, department_id, image) {
    const form = new FormData();
    form.append("id", id);
    form.append("name", name);
    // form.append("username", username);
    form.append("email", email);
    if (password !== null) {
        form.append("password", password);
    }
    form.append("privilege_id", privilege_id);
    form.append("department_id", department_id);
    form.append("image", image);


    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }

    try {
        let res = await client.post("/user/update", form, config);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function updateProfile(id, name, email, password, image) {
    const values = getLocalAuth()
    const profile = JSON.parse(values.authLocal);

    const form = new FormData();
    form.append("id", id);
    form.append("name", name);
    form.append("email", email);
    if (password !== null) {
        form.append("password", password);
    }
    form.append("image", image);


    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }

    try {
        let res = await client.post("/user/update", form, config);

        let userResponse = await client.get("/user/user_id/" + id);

        let userDetail = {
            status: "OK",
            message: "",
            data: {
                id: userResponse.data.data.id,
                name: userResponse.data.data.name,
                username: userResponse.data.data.username,
                email: userResponse.data.data.email,
                image: userResponse.data.data.image,
                department_id: userResponse.data.data.department_id,
                password: null,
                privilege_id: userResponse.data.data.privilege_id,
                created_by: userResponse.data.data.created_by,
                created_at: userResponse.data.data.created_at,
                updated_by: userResponse.data.data.updated_by,
                updated_at: userResponse.data.data.updated_at,
                privilege: {
                    name: userResponse.data.data.privilege.name
                },
                department: {
                    name: userResponse.data.data.department.name
                },
                token: profile.data.token
            }
        }

        let privilege = await client.get("/control-list/privilege_id/" + id);

        await setLocalAuth(JSON.stringify(userDetail), JSON.stringify(privilege.data));

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function importUser(file) {
    const form = new FormData();
    form.append("file", file);

    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }

    try {
        let res = await client.post("/user/upload", form, config);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function deleteUser(id) {
    try {
        let res = await client.delete("/user/user_id/" + id);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

export {
    fetchAllUser,
    fetchOneUser,
    createUser,
    updateUser,
    updateProfile,
    importUser,
    deleteUser,
};
